import type { ClipboardEvent, FormEvent } from "react";
import { hasPayerAngleBrackets, normalizePayerFreeText, payerTextPattern, payerTextMessage, preventUnsafePayerPaste } from "./CobPayers/payerTextValidation";

export const cobBusinessTextPattern = payerTextPattern;
export const cobBusinessTextMessage = payerTextMessage;
export const hasCobAngleBrackets = hasPayerAngleBrackets;

export function isValidCobInvoiceNumber(value?: string | null): boolean {
    return typeof value === "string" && value.trim().length > 0 && !hasCobAngleBrackets(value);
}

export function preventInvalidCobTextInput(event: FormEvent<HTMLElement>, onRejected?: () => void): void {
    const input = event.nativeEvent as InputEvent;
    if (input.isComposing) return;
    const data = (event as FormEvent<HTMLElement> & { data?: string }).data ?? input.data;
    if (data && hasCobAngleBrackets(data)) {
        event.preventDefault();
        onRejected?.();
    }
}

export function preventInvalidCobTextPaste(event: ClipboardEvent<HTMLElement>, onRejected: () => void = () => {}): void {
    preventUnsafePayerPaste(event, onRejected);
}

export function normalizeCobBusinessText(value: string, previousValue?: string, maxLength?: number, onRejected?: () => void): string {
    const previous = previousValue ?? "";
    const nextValue = normalizePayerFreeText(value, previous, maxLength);
    if (hasCobAngleBrackets(value) && nextValue === previous && value !== previous) onRejected?.();
    return nextValue;
}
